import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEnCA from '@angular/common/locales/en-CA';
import localeFrCA from '@angular/common/locales/fr-CA';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalModule } from './global/global.module';
import * as Component from './pages';
import { PublicComponent } from './public.component';
// ==
// causing more issues than it's solving - we may come back to it
// on a later date when we've enough time
// ==
// import { TrimValueAccessorModule } from "ng-trim-value-accessor";
import { AuthGuard, PlanGuard } from './_guards';
import {
  CmsApiService,
  ItsrApiService,
  MixpanelService,
  ReimbursmentsService,
  SessionTimeoutService
} from './_services';
import { RefreshTokenInterceptor } from './_services/RefrshTokenInterceptor';

registerLocaleData(localeEnCA);
registerLocaleData(localeFrCA);

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    GlobalModule,
    AppRoutingModule //,
    // TrimValueAccessorModule
  ],
  declarations: [
    AppComponent,
    PublicComponent,
    Component.HomeComponent,
    Component.FeaturesComponent,
    Component.StaticPublicComponent,
    Component.LoginComponent,
    Component.ForgotpasswordComponent,
    Component.ForgotpasswordSubmitComponent,
    Component.ActivateComponent,
    Component.ConditionsPageComponent
  ],
  exports: [],
  providers: [
    SessionTimeoutService,
    AuthGuard,
    PlanGuard,
    CmsApiService,
    ItsrApiService,
    ReimbursmentsService,
    MixpanelService,
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts